<template>
  <div>
    <RechargeListFilters />

    <v-card outlined>
      <v-data-table
        disable-sort
        hide-default-footer
        mobile-breakpoint="20"
        :headers="headers"
        :items="recharges"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        :no-data-text="$t('appointment.table.noData')"
        :loading-text="$t('appointment.table.loading')"
      >
        <template v-slot:[`item.type`]="{ item }">
          <div class="d-flex" v-if="item.type === 'ASAAS_BOLETO'">
            <v-icon color="grey lighten-2" left>mdi-barcode</v-icon>
            <div class="align-self-center ml-2">
              {{ $t('recharge.billet.title') }}
            </div>
          </div>
          <div class="d-flex" v-if="item.type === 'ASAAS_CREDIT_CARD'">
            <v-icon color="grey lighten-2" left>mdi-credit-card-outline</v-icon>
            <div class="align-self-center ml-2">
              {{ $t('recharge.card.title') }}
            </div>
          </div>
          <div class="d-flex" v-if="item.type === 'ASAAS_PIX'">
            <PixIcon width="30" height="20" opacity="0.15" />
            <div class="align-self-center ml-2">
              {{ $t('recharge.pix.title') }}
            </div>
          </div>
        </template>
        <template v-slot:[`item.code`]="{ item }">
          <span v-if="item.code" class="font-weight-bold">{{ item.code }}</span>
          <span v-else>---</span>
        </template>
        <template v-slot:[`item.comment`]="{ item }">
          <v-tooltip v-if="item.comment" top>
            <template v-slot:activator="{ on, attrs }">
              <span  class="d-block text-truncate mw-200" v-bind="attrs" v-on="on">
                {{ item.comment }}
              </span>
            </template>
            <div>
              <span>
                {{ item.comment }}
              </span>
            </div>
          </v-tooltip>
        </template>
        <template v-slot:[`item.date_created`]="{ item }">
          {{ date(item.date_created) }}
        </template>
        <template v-slot:[`item.due_date`]="{ item }">
          {{ formatDueDate(item.due_date) }}
        </template>
        <template v-slot:[`item.value`]="{ item }">
          {{ money(item.value) }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip :color="handleStatusColor(item.status)" small>
            {{ $t(`recharge.status.${item.status}`) }}
          </v-chip>
        </template>
        <template v-slot:[`item.attachments`]="{ item }">
          <v-btn
            v-if="isBilletAndPending(item)"
            :href="item.external_doc"
            target="_blank"
            color="primary"
            elevation="0"
            class="ml-5"
            download
            outlined
            small
          >
            <v-icon left small> mdi-tray-arrow-down </v-icon>
            <span class="caption">
              {{ $t('recharge.billet.billetDownload') }}
            </span>
          </v-btn>
          <v-btn
            v-if="isPixAndPending(item)"
            @click="() => setPixData(item)"
            color="primary"
            elevation="0"
            class="ml-5"
            download
            outlined
            small
          >
            <v-icon left small> mdi-tray-arrow-down </v-icon>
            <span class="caption">
              {{ $t('recharge.pix.payPix') }}
            </span>
          </v-btn>

          <span
            v-if="showDashes(item)"
            class="caption grey--text text--lighten-1"
          >
            ---
          </span>
        </template>
      </v-data-table>
    </v-card>

    <h-pagination :fetch="fetchRecharges" />

    <ModalRechargeByPix :pixData="pixData" />
  </div>
</template>

<script>
import PixIcon from '@/components/icons/Pix'
import RechargeListFilters from '@/components/recharge/RechargeListFilters'
import ModalRechargeByPix from '@/components/recharge/modals/ModalRechargeByPix'

import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { catalogMonetary, catalogDate } from '@/util/catalog'
import { rechargeHeaders } from '@/views/listHeaders/rechargeHeaders'
import { handleColors } from '@/util/colors'

export default {
  name: 'RechargeList',

  components: {
    PixIcon,
    ModalRechargeByPix,
    RechargeListFilters,
  },

  computed: {
    ...mapGetters(['isLoading', 'recharges', 'itemsPerPage']),
  },

  methods: {
    ...mapActions(['openModal', 'fetchRecharges']),

    handleStatusColor(status) {
      return handleColors(status)
    },

    setPixData(item) {
      this.pixData = item
      this.openModal('RECHARGE_BY_PIX_MODAL')
    },

    showDashes(item) {
      if (
        (item.status === 'RECEIVED' ||
          item.status === 'CONFIRMED' ||
          item.status === 'OVERDUE') &&
        item.type !== 'ASAAS_BOLETO'
      )
        return true
    },

    isBilletAndPending(item) {
      return item.status !== 'CONFIRMED' && item.type === 'ASAAS_BOLETO'
    },

    isPixAndPending(item) {
      return item.status === 'PENDING' && item.type === 'ASAAS_PIX'
    },

    formatDueDate(dueDate) {
      if (!dueDate) return '—'
      return moment(dueDate).format('DD/MM/YYYY')
    },
  },

  data() {
    return {
      pixData: {},

      headers: rechargeHeaders,
      money: catalogMonetary,
      date: catalogDate,
    }
  },

  mounted() {
    this.fetchRecharges()
  }
}
</script>
